
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/--roboneo/home",
      function () {
        return require("private-next-pages/--roboneo/home/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/--roboneo/home"])
      });
    }
  